import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart",
  "use": "icon-heart-usage",
  "viewBox": "0 0 18 15",
  "content": "<symbol viewBox=\"0 0 18 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-heart\">\n<path d=\"M17.9966 5.09648C17.9966 2 15.9966 0 13.222 0C10.9966 0 9.99658 1 8.99828 2.62105C7.99658 1 6.99656 0 4.7746 0C2.03285 0 1.96206e-05 2 0 5.09648C-2.94094e-05 9.7378 7.99655 15 8.99657 15C9.99658 15 17.9966 10 17.9966 5.09648Z\" fill=\"#F7716E\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol